export const UNREGISTERED_USER_ID: string = '00000000-0000-0000-0000-000000000000'

/**
 * カスタムオペレーション定数
 *
 * useEventSystem の custom step で使用するオペレーション文字列を定数化。
 */
export const EVENT_OPERATIONS = {
  OPEN_NAME_CHANGE_DIALOG: 'OPEN:NameChangeDialog',
  OPEN_FAIRY_BROKER_DIALOG: 'OPEN:FairyBrokerDialog',
  OPEN_KEY_INPUT_DIALOG: 'OPEN:KeyInputDialog',
  OPEN_GIFT_KEY_INPUT_DIALOG: 'OPEN:GiftKeyInputDialog',
  OPEN_REMIX_SOURCE_DIALOG: 'OPEN:RemixSourceDialog',
  OPEN_CRYSTALLIZE_PREVIEW_DIALOG: 'OPEN:CrystallizePreviewDialog',
  OPEN_CRYSTALLIZE_DIALOG: 'OPEN:CrystallizeDialog',
  PLAY_GODDESS_ORACLE: 'PLAY:GoddessOracle',
  PLAY_ENCODIA: 'PLAY:Encodia',
  PLAY_CODEX_IN_YOUR_HANDS: 'PLAY:CodexInYourHands',
  PLAY_NONE: 'PLAY:None',
  NOP: 'NOP',
} as const

export type EventOperation = typeof EVENT_OPERATIONS[keyof typeof EVENT_OPERATIONS]

/**
 * Pyxel 公式 User Examples の投稿先（GitHub Discussions フォーム）。
 *
 * 作品の投稿支援（#681 / #682）で「投稿ページを開く」リンク先に使う。
 * カテゴリ slug が変わったときはここを更新する（運用更新ポイント）。
 * 仕様: doc/domain/pyxel_user_examples_submission.md
 */
export const PYXEL_USER_EXAMPLES_URL: string
  = 'https://github.com/kitao/pyxel/discussions/new?category=user-examples'
